module.exports = "/_next/static/images/6636d440187c970b257f1eed828fd793-credit-card-prepayment@2x.png.webp";